import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { constObj } from 'src/app/common/Constants/constants';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { CommonDataService } from '../../common/services/common-data.service';
import { SttSortingService } from '../../common/services/stt-sorting.service';

export interface StandardReport {
  Paragraph: number;
  Sequence: string;
  Topic: string;
}

export interface sourceTracingInputData {
  Collection: string;
  SectionTitle: string;
  SectionNumber: string;
  ParaNumber: string;
  ParaType: string;
  AuthType: string;
  pageNumber: number;
}

const ByStandard_Report_Data: StandardReport[] = [
  { Paragraph: 1, Sequence: '15.2.1.2.1', Topic: '405-20-55-5' },
  { Paragraph: 2, Sequence: '278.2.1', Topic: '860-20-55-25' },
  { Paragraph: 3, Sequence: '284.1.2', Topic: '405-20-55-24A' },
];

@Component({
  selector: 'app-source-tracing-tool',
  templateUrl: './source-tracing-tool.component.html',
  styleUrls: ['./source-tracing-tool.component.css']
})

export class SourceTracingToolComponent implements OnInit {
  data: boolean = false;
  Op_form_enable: boolean = true;
  Cod_form_enable: boolean = false;
  CIG_form_enable: boolean = false;

  stt_header: string;
  stt_subtitle: string;
  stt_info: string;
  stt_byOriginalPronouncement: string;
  stt_pronouncementtype: string;
  stt_referencetype: string;
  stt_excludesources: string;
  stt_includesources: string;
  stt_number: string;
  stt_paragraph: string;
  stt_reportfor: string;
  stt_byCodification: string;
  stt_section: string;
  stt_paragraphOrFootnote: string;

  stt_byCIG: string;
  stt_chapter: string;
  stt_pfqag: string;

  stt_startOver: string;
  stt_generate: string;
  stt_accordion1: string;
  stt_accordion2: string;
  stt_accordion3: string;
  stt_accordion4_footnote: string;
  stt_accordion5_qandA: string;
  stt_links;
  stt_tablekey: string;
  cigChapters: string;

  stt_maintenanceflag: boolean = false;
  stt_maintenanceMessage: string = "";

  SelectedSearch: string;
  pronouncementNumberCombination: string = "";
  pronouncementNumberCombinationArray;
  FinalCombination: any = [];
  FinalNumber: any = [];
  tempPronouncement: string = "";
  tempCombination: any = [];
  tempNumbers: any = [];
  cigChapterList: any = [];

  CodificationForm: FormGroup;
  CIGForm: FormGroup;
  OpForm: FormGroup;

  generate_btn_enable: boolean = false;
  start_over_btn_enable: boolean = false;

  panelOpenState: boolean = false;
  generateReport: boolean = false;
  noRecords = constObj.Norecords;
  public displayedColumns = ["Paragraph", "Sequence", "Topic"];
  public dataSource_standard_glossaryTerms = new MatTableDataSource<any>();
  public dataSource_standard_nonAuthoritive = new MatTableDataSource<any>();
  public dataSource_standard_paragraph = new MatTableDataSource<any>();
  public dataSource_standard_footnote = new MatTableDataSource<any>();
  public dataSource_standard_questions = new MatTableDataSource<any>();
  columnDetails: any;
  glossaryColumnDetails: any;
  dataSource_Standard = ByStandard_Report_Data;

  sourceTracingData: sourceTracingInputData = {
    Collection: "",
    SectionTitle: "",
    SectionNumber: "",
    ParaNumber: "",
    ParaType: "",
    AuthType: "",
    pageNumber: 0
  }
  @ViewChild('TableOneSort', { static: true }) sort_Standard: MatSort;
  @ViewChild('TableTwoSort', { static: true }) sortOP: MatSort;
  @ViewChild('TableOnePaginator', { static: true }) paginatorCod: MatPaginator;
  @ViewChild('TableTwoPaginator', { static: true }) paginatorOP: MatPaginator;

  SectionTitleList: any = [];
  SectionNumberList: any = [];
  ParaTypeList: any = [];
  TabSequence = [];
  leftNavmenuLevel = [0, 1, 2];
  codification = ["Codification"];
  originalPronouncements = ["Original Pronouncements"];
  implementationGuide = ["Comprehensive Implementation Guide"];
  hideCIGFromSTT: boolean;
  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, private formBuilder: FormBuilder
    , private santize: DomSanitizer, private sttSort: SttSortingService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.graphQlService.getCIGParamValue().subscribe(response => {
      this.hideCIGFromSTT = response.toLowerCase() == 'true';
    });
    this.initializeForms();

    this.graphQlService.getESSourceTracingToolDropdown("OP").subscribe(dropdownData => {
      this.commonDataService.showLoader.next(true);
      this.LoadDropDownValues("OP", dropdownData);
      this.commonDataService.showLoader.next(false);
    })
    this.OpForm.enable();
    this.OpForm.controls["TypeValue"].disable()
    this.CodificationForm.disable();
    this.CIGForm.disable();

    this.getSourceTracingToolLabels();
    let leftnav = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    if (leftnav) {
      leftnav.forEach(columnLabels => {
        if (columnLabels?.item?.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()) || columnLabels?.item?.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()) || columnLabels?.item?.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase())) {
          this.TabSequence.push(columnLabels.item);
        }
      });
    }
    if (this.TabSequence.length < 3) {
      if (!this.TabSequence.some(x => x.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()))) {
        this.TabSequence.push(this.codification[0]);
      }
      if (!this.TabSequence.some(x => x.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()))) {
        this.TabSequence.push(this.originalPronouncements[0]);
      }
      if (!this.TabSequence.some(x => x.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase()))) {
        this.TabSequence.push(this.implementationGuide[0]);
      }
    }
    // this.buttonActive = true;
    this.OpForm.valueChanges.subscribe(
      () => {
        if (!((this.OpForm.get("PronouncementType").value == "" || this.OpForm.get("PronouncementType").value == null) && (this.OpForm.get("Number").value == "" || this.OpForm.get("Number").value == null) &&
          (this.OpForm.get("ParaType").value == "" || this.OpForm.get("ParaType").value == null) && (this.OpForm.get("TypeValue").value == "" || this.OpForm.get("TypeValue").value == null))) {
          this.buttonActive = ((this.OpForm.get("PronouncementType").value != "" && this.OpForm.get("PronouncementType").value != null) && (this.OpForm.get("Number").value != "" && this.OpForm.get("Number").value != null));
        } else {
          this.buttonActive = false;
        }
      });

    this.CodificationForm.valueChanges.subscribe(
      () => {
        if (!((this.CodificationForm.get("Section").value == "" || this.CodificationForm.get("Section").value == null) &&
          (this.CodificationForm.get("CODType").value == "" || this.CodificationForm.get("CODType").value == null) && (this.CodificationForm.get("TypeValue").value == "" || this.CodificationForm.get("TypeValue").value == null))) {
          this.buttonActive = (this.CodificationForm.get("Section").value != "" && this.CodificationForm.get("Section").value != null) ? true : false;
        } else {
          this.buttonActive = false;
        }
      });

    this.CIGForm.valueChanges.subscribe(
      () => {
        if (!((this.CIGForm.get("Chapter").value == "" || this.CIGForm.get("Chapter").value == null) &&
          (this.CIGForm.get("CIGType").value == "" || this.CIGForm.get("CIGType").value == null) && (this.CIGForm.get("TypeValue").value == "" || this.CIGForm.get("TypeValue").value == null))) {
          this.buttonActive = true;
        } else {
          this.buttonActive = false;
        }
      });
  }

  ngAfterContentChecked() {
    this.EnableBackToTop();
  }

  buttonActive: boolean = false;
  opdropdownList: string[] = [];
  cigdropdownList: string[] = [];

  getSourceTracingToolLabels() {
    this.commonDataService.showLoader.next(true);
    // this.graphQlService.getSourceTracingToolDropdown().subscribe(data => { this.cigdropdownList = data.content.data.listItem; this.opdropdownList = this.cigdropdownList.slice(0, 3); });

    this.graphQlService.getSourceTracingToolLabel().subscribe(labelsData => {
      //this.hideCIGFromSTT = labelsData.hideCIGFromSTT;
      var labels = labelsData.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.stt_header = labels.filter(x => x.key == "stt_header").map(y => y.value);
      this.stt_maintenanceflag = labels.filter(x => x.key == "stt_maintenanceflag").map(x => x.value.toLowerCase() === "true")[0];
      this.stt_maintenanceMessage = labels.filter(x => x.key == "stt_maintenanceMessage").map(y => y.value);
      this.stt_subtitle = labels.filter(x => x.key == "stt_subtitle").map(y => y.value);
      this.stt_info = labels.filter(x => x.key == "stt_info").map(y => y.value);
      this.stt_byOriginalPronouncement = labels.filter(x => x.key == "stt_byOriginalPronouncement").map(y => y.value);
      this.stt_pronouncementtype = labels.filter(x => x.key == "stt_pronouncementtype").map(y => y.value);
      this.stt_referencetype = labels.filter(x => x.key == "stt_referencetype").map(y => y.value);
      this.stt_excludesources = labels.filter(x => x.key == "stt_excludesources").map(y => y.value);
      this.stt_includesources = labels.filter(x => x.key == "stt_includesources").map(y => y.value);
      this.stt_reportfor = labels.filter(x => x.key == "stt_reportfor").map(y => y.value);
      this.stt_number = labels.filter(x => x.key == "stt_number").map(y => y.value);
      this.stt_paragraph = labels.filter(x => x.key == "stt_paragraphQuestionOrFootnote").map(y => y.value);

      this.stt_byCodification = labels.filter(x => x.key == "stt_byCodification").map(y => y.value);
      this.stt_paragraphOrFootnote = labels.filter(x => x.key == "stt_paragraphQuestionOrFootnote").map(y => y.value);
      this.stt_section = labels.filter(x => x.key == "stt_section").map(y => y.value);

      this.stt_byCIG = labels.filter(x => x.key == "stt_byCIG").map(y => y.value);
      this.stt_chapter = labels.filter(x => x.key == "stt_chapter").map(y => y.value);
      this.stt_pfqag = labels.filter(x => x.key == "stt_pfqag").map(y => y.value);

      this.stt_startOver = labels.filter(x => x.key == "stt_startOver").map(y => y.value);
      this.stt_generate = labels.filter(x => x.key == "stt_generate").map(y => y.value);
      this.cigChapters = labels.filter(x => x.key == "cig_chapters").map(y => y.value);
      this.cigChapterList = this.cigChapters[0].split(",");
      this.pronouncementNumberCombination = labels.filter(x => x.key == "pronouncement_number_combination").map(y => y.value);
      this.pronouncementNumberCombinationArray = this.pronouncementNumberCombination[0].split(",");
      for (let i = 0; i < this.pronouncementNumberCombinationArray.length; i++) {
        if (this.tempPronouncement != this.pronouncementNumberCombinationArray[i].split(":")[0]) {
          if (this.tempPronouncement != "") {
            this.tempCombination = { "pronouncement": this.tempPronouncement, "numbers": this.tempNumbers };
            this.FinalCombination.push(this.tempCombination);
          }
          this.tempNumbers = [];
          this.tempPronouncement = this.pronouncementNumberCombinationArray[i].split(":")[0];
        }
        this.tempNumbers.push(this.pronouncementNumberCombinationArray[i].split(":")[1]);
      }

      this.stt_accordion1 = labels.filter(x => x.key == "stt_accordion1").map(y => y.value);
      this.stt_accordion2 = labels.filter(x => x.key == "stt_accordion2").map(y => y.value);
      this.stt_accordion3 = labels.filter(x => x.key == "stt_accordion3").map(y => y.value);
      this.stt_accordion4_footnote = labels.filter(x => x.key == "stt_accordion4_footnote").map(y => y.value);
      this.stt_accordion5_qandA = labels.filter(x => x.key == "cig_questionAndAnswers").map(y => y.value);
      this.stt_links = this.santize.bypassSecurityTrustHtml(labels.filter(x => x.key == "stt_links").map(y => y.value));
      this.stt_tablekey = labels.filter(x => x.key == "stt_tablekey").map(y => y.value);
      var res = this.commonDataService.backbutton_sourcetracing.getValue();
      if (res) { this.LoadCrossRefBackfromContenPage() }
      // this.commonDataService.showLoader.next(false);
    })
  }

  initializeForms() {
    this.OpForm = this.formBuilder.group({
      PronouncementType: [''],
      Number: [''],
      ParaType: [''],
      TypeValue: ['']
    });

    this.CodificationForm = this.formBuilder.group({
      Section: [''],
      CODType: [''],
      TypeValue: ['']
    });

    this.CIGForm = this.formBuilder.group({
      Chapter: [''],
      CIGType: [''],
      TypeValue: ['']
    });
  }
  number: any = [];
  enableNumber: boolean = true;
  CodificationForm_Section: any;
  CIGForm_Chapter: any;
  enableOPreferencetype: boolean = true;
  CODSectionPlaceholder: string = "Examples: 1200, A10, Sp20";
  onPronouncementChange(event) {
    this.ParaTypeList = [];
    this.OpForm.controls['Number'].setValue("");
    this.OpForm.controls['ParaType'].setValue("");
    this.OpForm.controls['TypeValue'].setValue("");
    this.SectionNumberList = this.SectionTitleList.find(x => x.key == event.value).sourceStatements.buckets;
    this.SectionNumberList = this.SectionNumberList = this.SectionNumberList.sort((a, b) => (Number(a.key.replace("-", "")) < Number(b.key.replace("-", ""))) ? -1 : 1);
    this.SectionNumberList.forEach(SectionNumbers => {
      let paraTypes = SectionNumbers.sourceParaTypes.buckets;
      paraTypes.forEach(parakey => {
        let obj = {
          key: parakey.key
        }
        let paraTypeExist = this.ParaTypeList.filter(x => x.key == obj.key)
        if (paraTypeExist.length == 0) {
          this.ParaTypeList.push(obj);
        }
      })

    })
    /*  this.SectionNumberList.unshift({ key: "--Select--" });*/
    this.ParaTypeList = this.ParaTypeList.sort((a, b) => (a.key < b.key) ? -1 : 1);
    /*    this.ParaTypeList.unshift({ key: "--Select--" });*/
    // this.number = this.FinalCombination.filter(x => x.pronouncement == event.value);
    // this.FinalNumber = this.number[0].numbers;
    if (this.SectionNumberList.length > 0) {
      this.enableNumber = false;
    }
    else {
      this.enableNumber = true;
    }
  }

  enableOPTypeValue: boolean = true;
  enableCODTypeValue: boolean = true;
  enableCIGTypeValue: boolean = true;
  OPTypeSelected: string = "";
  CODTypeSelected: string = "";
  CIGTypeSelected: string = "";
  OPPlaceholder: string = "";
  CODPlaceholder: string = "";
  CIGPlaceholder: string = "";
  onOPTypeChange(event) {
    this.OPTypeSelected = event.value;
    if (event.value == "Paragraph") { this.OPTypeSelected = "Paragraph number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: 1"; }
    else if (event.value == "Question") { this.OPTypeSelected = "Question number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: 4.1"; }
    else if (event.value == "Footnote") { this.OPTypeSelected = "Footnote number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: fn1"; }
    else if (event.value == "Glossterm") { this.OPTypeSelected = "Glossary term"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: affiliates"; }
    else if (event.value == "Appendix") { this.OPTypeSelected = "Appendix"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: B1-2"; }
    else { this.enableOPTypeValue = true; }
    if (this.enableOPTypeValue == true) { this.OpForm.controls["TypeValue"].disable() } else { this.OpForm.controls["TypeValue"].enable() }
  }

  onCODTypeChange(event) {
    this.CODTypeSelected = event.value;
    if (event.value == "Paragraph") { this.CODTypeSelected = "Paragraph number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: .101"; }
    else if (event.value == "Question") { this.CODTypeSelected = "Question number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: .701-1"; }
    else if (event.value == "Footnote") { this.CODTypeSelected = "Footnote number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: fn1"; }
    else if (event.value == "Glossterm") { this.CODTypeSelected = "Glossary term"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: affiliates"; }
    else if (event.value == "Appendix") { this.CODTypeSelected = "Appendix"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: B1-2"; }
    else { this.enableCODTypeValue = true; }
    if (this.enableCODTypeValue == true) { this.CodificationForm.controls["TypeValue"].disable() } else { this.CodificationForm.controls["TypeValue"].enable() }
  }

  onCIGTypeChange(event) {
    this.CIGTypeSelected = event.value;
    if (event.value == "Paragraph") { this.CIGTypeSelected = "Paragraph number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: 1"; }
    else if (event.value == "Question") { this.CIGTypeSelected = "Question number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: 1.2.2"; }
    else if (event.value == "Footnote") { this.CIGTypeSelected = "Footnote number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: fn1"; }
    else if (this.CIGTypeSelected == "Appendix") { this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: B1-2"; }
    else if (this.CIGTypeSelected == "Glossary Term") { this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: affiliates"; }
    else { this.enableCIGTypeValue = true; }
    if (this.enableCIGTypeValue == true) { this.CIGForm.controls["TypeValue"].disable() } else { this.CIGForm.controls["TypeValue"].enable() }
  }

  onSearchOptionChange(searchoption: string) {
    this.SelectedSearch = searchoption;
    this.commonDataService.showLoader.next(true);
    this.SectionNumberList = [];
    this.SectionTitleList = [];
    this.ParaTypeList = [];
    this.isPrimary = "primary";
    this.buttonActive = false;
    this.graphQlService.getESSourceTracingToolDropdown(searchoption).subscribe(data => {
      if (data) {
        this.LoadDropDownValues(searchoption, data);
      }
    })

    var Standard_div = document.getElementById("Standard");
    var Codification_div = document.getElementById("Codification");
    var CIG_div = document.getElementById("CIG");

    if (searchoption == "OP") {
      this.OpForm.enable();
      this.OpForm.controls["TypeValue"].disable()
      this.CodificationForm.disable();
      this.CIGForm.disable();
      this.enableNumber = true;
      this.Op_form_enable = true;
      this.Cod_form_enable = false;
      this.CIG_form_enable = false;

      this.enableCODTypeValue = true;
      this.enableCIGTypeValue = true;
      this.CODTypeSelected = "";
      this.CIGTypeSelected = "";
      this.CODPlaceholder = "";
      this.CIGPlaceholder = "";

      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;

      Standard_div.className += " search_area_highlight";
      Codification_div.classList.remove("search_area_highlight");
      CIG_div.classList.remove("search_area_highlight");
    }
    else if (searchoption == "COD") {
      this.CodificationForm.enable();
      this.CodificationForm.controls["TypeValue"].disable();
      this.OpForm.disable();
      this.CIGForm.disable();

      this.Cod_form_enable = true;
      this.Op_form_enable = false;
      this.CIG_form_enable = false;

      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;
      this.enableOPTypeValue = true;
      this.enableCIGTypeValue = true;
      this.OPTypeSelected = "";
      this.CIGTypeSelected = "";
      this.OPPlaceholder = "";
      this.CIGPlaceholder = "";

      Codification_div.className += " search_area_highlight";
      Standard_div.classList.remove("search_area_highlight");
      CIG_div.classList.remove("search_area_highlight");
    }
    else if (searchoption == "CIG") {
      this.CodificationForm.disable();
      this.OpForm.disable();
      this.CIGForm.enable();
      this.CIGForm.controls["TypeValue"].disable()
      this.Cod_form_enable = false;
      this.Op_form_enable = false;
      this.CIG_form_enable = true;
      this.enableOPTypeValue = true;
      this.enableCODTypeValue = true;
      this.OPTypeSelected = "";
      this.CODTypeSelected = "";
      this.OPPlaceholder = "";
      this.CODPlaceholder = "";

      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;

      CIG_div.className += " search_area_highlight";
      Standard_div.classList.remove("search_area_highlight");
      Codification_div.classList.remove("search_area_highlight");
    }

  }

  LoadDropDownValues(searchSection: string, data: any) {
    this.SectionNumberList = [];
    this.SectionTitleList = [];
    this.ParaTypeList = [];
    if (searchSection == "OP") {
      this.SectionTitleList = data.aggregations.sourceCollections.buckets;
      this.SectionTitleList = this.SectionTitleList.sort((a, b) => (a.key < b.key) ? -1 : 1);
      /*      this.SectionTitleList.unshift({key: "--Select--"});*/
      // this.SectionNumberList=data.aggregations.sourceCollections.buckets.find(x=>x.key.toLowerCase()==searchSection.toLowerCase())?.sourceStatements?.buckets?.filter(x=>x.targetSectionNumbers.buckets[0].key=="I50");
      // this.ParaTypeList = data.aggregations.sourceParaTypes.buckets;
      // this.ParaTypeList = this.ParaTypeList.sort((a, b) => (a.key < b.key) ? -1 : 1);
    }
    else if (searchSection == "CIG") {
      this.SectionNumberList = data.aggregations.sourceCollections.buckets;
      this.SectionNumberList = this.SectionNumberList.sort((a, b) => (a.key < b.key) ? -1 : 1);
      var isChapterZExist = this.SectionNumberList.find(x => x.key.includes("Z"));
      if (isChapterZExist) {
        var index = this.SectionNumberList.indexOf(this.SectionNumberList.find(x => x.key == "Z"), 0);
        if (index > -1) {
          this.SectionNumberList.splice(index, 1);
        }

      }
      this.SectionNumberList = this.SectionNumberList.sort((a, b) => Number(a.key) > Number(b.key) ? 1 : -1);
      if (isChapterZExist) {
        this.SectionNumberList.push(isChapterZExist);
      }
      /*      this.SectionTitleList.unshift({key: "--Select--"});*/
      // this.SectionNumberList=data.aggregations.sourceCollections.buckets.find(x=>x.key.toLowerCase()==searchSection.toLowerCase())?.sourceStatements?.buckets?.filter(x=>x.targetSectionNumbers.buckets[0].key=="I50");
      // this.ParaTypeList = data.aggregations.sourceParaTypes.buckets;
      // this.ParaTypeList = this.ParaTypeList.sort((a, b) => (a.key < b.key) ? -1 : 1);
    }
    else {
      this.ParaTypeList = data.aggregations.targetParatypes.buckets;
      this.ParaTypeList = this.ParaTypeList.sort((a, b) => (a.key < b.key) ? -1 : 1);
      /*    this.ParaTypeList.unshift({ key: "--Select--" });*/
      this.SectionNumberList = data.aggregations.targetSectionNumbers.buckets;
      this.SectionNumberList = this.SectionNumberList.sort((a, b) => (a.key < b.key) ? -1 : 1);
      //this.SectionNumberList.unshift({ key: "--Select--" });
    }
    this.commonDataService.showLoader.next(false);
    // localStorage.setItem("SourceTracingToolDropdown",JSON.stringify(data));


  }
  StartOver() {
    this.CodificationForm.reset({}); this.OpForm.reset({}); this.CIGForm.reset({});
    this.enableNumber = true; this.generateReport = false;
    this.OPPlaceholder = ''; this.OPTypeSelected = ''; this.CODTypeSelected = ''; this.CODPlaceholder = ''; this.CIGTypeSelected = ''; this.CIGPlaceholder = '';
    this.buttonActive = false; this.data = false;
    this.isPrimary = 'primary';
    this.CIGForm.controls["TypeValue"].disable()
    this.CodificationForm.controls["TypeValue"].disable();
    this.OpForm.controls["TypeValue"].disable()
    localStorage.removeItem("sourceTracingTool");
    localStorage.removeItem("sourceTracingToolData");
  }
  isPrimary: string = "primary";
  primaryRadioButtonChange(event) {
    this.isPrimary = event;
    this.buttonActive = (this.CodificationForm.dirty && this.CodificationForm.controls['Section'].value != "") || (this.OpForm.dirty && (this.OpForm.controls['PronouncementType'].value != "" && this.OpForm.controls['Number'].value != "")) || this.CIGForm.dirty ? true : false;
  }

  opColSpan: number = 0;
  standformValues: string = "";
  codformValues: string = "";
  cigformValues: string = "";
  SearchSection: string = "";
  paragraphData = [];
  glossaryData = [];
  LoadCrossRefBackfromContenPage() {

    this.initializeForms();
    
    let inputData = JSON.parse(localStorage.getItem("sourceTracingTool"));
    this.sourceTracingData = JSON.parse(localStorage.getItem("sourceTracingToolData"));

    this.LoadDropDownForms(this.sourceTracingData)
    this.generateReport = true;
    this.GenerateReportfrombackButton(inputData.CodificationForm.data, inputData.OpForm.data, inputData.CigForm.data);
    this.commonDataService.backbutton_sourcetracing.next(false);
  }
  LoadDropDownForms(sourceTracingData) {
    this.isPrimary = sourceTracingData.AuthType;
    let searchoption = sourceTracingData.Collection
    var Standard_div = document.getElementById("Standard");
    var Codification_div = document.getElementById("Codification");
    var CIG_div = document.getElementById("CIG");
    if (searchoption == "OP") {
      this.OpForm.enable();
      this.OpForm.controls["TypeValue"].disable()
      this.OpForm.markAsDirty()
      this.CodificationForm.disable();
      this.CIGForm.disable();
      this.enableNumber = true;
      this.Op_form_enable = true;
      this.Cod_form_enable = false;
      this.CIG_form_enable = false;
      this.radioOP = true;
      this.radioCOD = false;
      this.radioCIG = false;
      this.enableCODTypeValue = true;
      this.enableCIGTypeValue = true;
      this.CODTypeSelected = "";
      this.CIGTypeSelected = "";
      this.CODPlaceholder = "";
      this.CIGPlaceholder = "";

      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;
      if (sourceTracingData.SectionTitle != "") {
        this.enableNumber = false;
        this.graphQlService.getESSourceTracingToolDropdown("OP").subscribe(dropdownData => {
          this.LoadDropDownValues("OP", dropdownData);
          this.ParaTypeList = [];
          this.SectionNumberList = this.SectionTitleList.find(x => x.key == sourceTracingData.SectionTitle).sourceStatements.buckets;
          this.SectionNumberList = this.SectionNumberList = this.SectionNumberList.sort((a, b) => (Number(a.key) < Number(b.key)) ? -1 : 1);
          this.SectionNumberList.forEach(SectionNumbers => {
            let paraTypes = SectionNumbers.sourceParaTypes.buckets;
            paraTypes.forEach(parakey => {
              let obj = {
                key: parakey.key
              }
              let paraTypeExist = this.ParaTypeList.filter(x => x.key == obj.key)
              if (paraTypeExist.length == 0) {
                this.ParaTypeList.push(obj);
              }
            })

          })
          //this.SectionNumberList.unshift({ key: "--Select--" });
          // this.number = this.FinalCombination.filter(x => x.pronouncement == event.value);
          // this.FinalNumber = this.number[0].numbers;
          if (this.SectionNumberList.length > 0) {
            this.enableNumber = false;
          }
          else {
            this.enableNumber = true;
          }

          this.commonDataService.showLoader.next(false);
        })
        this.OpForm.setValue({
          PronouncementType: sourceTracingData.SectionTitle,
          Number: sourceTracingData.SectionNumber,
          ParaType: sourceTracingData.ParaType,
          TypeValue: sourceTracingData.ParaNumber
        }, { emitEvent: true })

        this.OPTypeSelected = sourceTracingData.ParaType;
        this.OPTypeSelected = sourceTracingData.ParaType;
        if (sourceTracingData.ParaType == "Paragraph") { this.OPTypeSelected = "Paragraph number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: 1"; }
        else if (sourceTracingData.ParaType == "Question") { this.OPTypeSelected = "Question number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: 4.1"; }
        else if (sourceTracingData.ParaType == "Footnote") { this.OPTypeSelected = "Footnote number"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: fn1"; }
        else if (sourceTracingData.ParaType == "Glossterm") { this.OPTypeSelected = "Glossary term"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: affiliates"; }
        else if (sourceTracingData.ParaType == "Appendix") { this.OPTypeSelected = "Appendix"; this.enableOPTypeValue = false; this.OPPlaceholder = "Example: B1-2"; }

        else { this.enableOPTypeValue = true; }
        if (this.enableOPTypeValue == true) { this.OpForm.controls["TypeValue"].disable() } else { this.OpForm.controls["TypeValue"].enable() }


      }
      Standard_div.className += " search_area_highlight";
      Codification_div.classList.remove("search_area_highlight");
      CIG_div.classList.remove("search_area_highlight");
    }
    else if (searchoption == "COD") {
      this.CodificationForm.enable();
      this.CodificationForm.controls["TypeValue"].disable();

      this.CodificationForm.markAsDirty();
      this.OpForm.disable();
      this.CIGForm.disable();

      this.Cod_form_enable = true;
      this.Op_form_enable = false;
      this.CIG_form_enable = false;
      this.radioOP = false;
      this.radioCOD = true;
      this.radioCIG = false;
      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;
      this.enableOPTypeValue = true;
      this.enableCIGTypeValue = true;
      this.OPTypeSelected = "";
      this.CIGTypeSelected = "";
      this.OPPlaceholder = "";
      this.CIGPlaceholder = "";
      this.CodificationForm_Section = sourceTracingData.SectionNumber;
      if (this.CodificationForm_Section != "" && sourceTracingData.ParaType != "") {
        this.graphQlService.getESSourceTracingToolDropdown("COD").subscribe(dropdownData => {
          this.LoadDropDownValues(searchoption, dropdownData);
          this.commonDataService.showLoader.next(false);
        })
        this.CODReferenceTypeValueNgmodel = sourceTracingData.ParaType;

        //this.CodificationForm.get("Section").setValue(sourceTracingData.SectionNumber);
        //this.CodificationForm.get("CODType").setValue(sourceTracingData.ParaType);
        //this.CodificationForm.get("TypeValue").setValue(sourceTracingData.ParaNumber);
        this.CodificationForm.setValue({
          Section: sourceTracingData.SectionNumber,
          CODType: sourceTracingData.ParaType,
          TypeValue: sourceTracingData.ParaNumber,
        }, { onlySelf: false, emitEvent: true });
        this.CODformTypeValueNgmodel = sourceTracingData.ParaNumber
        this.CODTypeSelected = sourceTracingData.ParaType;
        if (sourceTracingData.ParaType == "Paragraph") { this.CODTypeSelected = "Paragraph number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: .101"; }
        else if (sourceTracingData.ParaType == "Question") { this.CODTypeSelected = "Question number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: .701-1"; }
        else if (sourceTracingData.ParaType == "Footnote") { this.CODTypeSelected = "Footnote number"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: fn1"; }
        else if (sourceTracingData.ParaType == "Glossterm") { this.CODTypeSelected = "Glossary term"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: affiliates"; }
        else if (sourceTracingData.ParaType == "Appendix") { this.CODTypeSelected = "Appendix"; this.enableCODTypeValue = false; this.CODPlaceholder = "Example: B1-2"; }
        else { this.enableCODTypeValue = true; }
        if (this.enableCODTypeValue == true) { this.CodificationForm.controls["TypeValue"].disable() } else { this.CodificationForm.controls["TypeValue"].enable() }
        //if (this.CodificationForm.controls["TypeValue"].enabled && sourceTracingData.ParaNumber != "") {
        //  this.CodificationForm.patchValue({
        //    TypeValue: sourceTracingData.ParaNumber
        //  })
        //  this.CODformTypeValueNgmodel = sourceTracingData.ParaNumber
        //}
      }


      Codification_div.className += " search_area_highlight";
      Standard_div.classList.remove("search_area_highlight");
      CIG_div.classList.remove("search_area_highlight");
    }
    else if (searchoption == "CIG") {
      this.CodificationForm.disable();
      this.OpForm.disable();
      this.CIGForm.enable();
      this.CIGForm.controls["TypeValue"].disable()
      this.CIGForm.markAsDirty()
      this.Cod_form_enable = false;
      this.Op_form_enable = false;
      this.CIG_form_enable = true;
      this.enableOPTypeValue = true;
      this.enableCODTypeValue = true;
      this.radioOP = false;
      this.radioCOD = false;
      this.radioCIG = true;
      this.OPTypeSelected = "";
      this.CODTypeSelected = "";
      this.OPPlaceholder = "";
      this.CODPlaceholder = "";

      // this.buttonActive = true;
      this.generateReport = false;
      this.data = false;
      this.graphQlService.getESSourceTracingToolDropdown("CIG").subscribe(dropdownData => {
        this.LoadDropDownValues("CIG", dropdownData);
        if (sourceTracingData.SectionNumber != "") {
          this.CIGForm_Chapter = sourceTracingData.SectionNumber
          this.CIGForm.setValue({
            Chapter: sourceTracingData.SectionNumber,
            CIGType: sourceTracingData.ParaType,
            TypeValue: sourceTracingData.ParaNumber
          }, { onlySelf: false, emitEvent: true })

          this.CIGTypeSelected = sourceTracingData.ParaType;
          if (sourceTracingData.ParaType == "Paragraph") { this.CIGTypeSelected = "Paragraph number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: 1"; }
          else if (sourceTracingData.ParaType == "Question") { this.CIGTypeSelected = "Question number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: 1.2.2"; }
          else if (sourceTracingData.ParaType == "Footnote") { this.CIGTypeSelected = "Footnote number"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: fn1"; }
          else if (this.CIGTypeSelected == "Appendix") { this.CIGTypeSelected = "Appendix"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: B1-2"; }
          else if (this.CIGTypeSelected == "Glossary Term") { this.CIGTypeSelected = "Glossary Term"; this.enableCIGTypeValue = false; this.CIGPlaceholder = "Example: affiliates"; }
          else { this.enableCIGTypeValue = true; }
          if (this.enableCIGTypeValue == true) { this.CIGForm.controls["TypeValue"].disable() } else { this.CIGForm.controls["TypeValue"].enable() }

          if (this.CIGForm.controls["TypeValue"].enabled) {
            this.CIGForm.patchValue({
              TypeValue: sourceTracingData.ParaNumber
            })
          }
        }
        this.commonDataService.showLoader.next(false);
      })


      CIG_div.className += " search_area_highlight";
      Standard_div.classList.remove("search_area_highlight");
      Codification_div.classList.remove("search_area_highlight");
    }
  }
  GenerateReportfrombackButton(CodificationForm, OpForm, CIGForm) {
    this.buttonActive = false;
    this.generateReport = false;
    this.data = false;
    this.columnDetails = [];
    this.dataSource_standard_paragraph.data = [];
    this.dataSource_standard_footnote.data = [];
    this.dataSource_standard_glossaryTerms.data = [];
    this.dataSource_standard_nonAuthoritive.data = [];
    this.dataSource_standard_questions.data = [];
    this.paragraphData = [];
    this.glossaryData = [];
    this.totalResultCount = 0;
    this.resultCount = 0;
    this.enableBackToTop = false;
    this.sourceTracingData = JSON.parse(localStorage.getItem("sourceTracingToolData"));
    this.commonDataService.showLoader.next(true);

    if (this.Op_form_enable && (!this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "OP";
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? data[0].currentRecordCount : 0;
          this.dataSource_standard_paragraph.data = data;
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })
      OpForm.PronouncementType = OpForm.PronouncementType == undefined ? "" : OpForm.PronouncementType;
      OpForm.Number = OpForm.Number == undefined ? "" : OpForm.Number;
      this.opColSpan = 1;
      this.standformValues = (OpForm.PronouncementType != null ? " " + OpForm.PronouncementType : "") + (OpForm.Number != null ? " " + OpForm.Number : "") + (OpForm.OPType != null ? " " + OpForm.OPType : "") + " " + (OpForm.TypeValue != null ? " " + OpForm.TypeValue : "");
      this.standformValues = this.standformValues.trim() == "" || this.standformValues == undefined ? "Pronouncement Type" : this.standformValues;
      // this.dataSource_standard_glossaryTerms.data = [];
      this.dataSource_standard_nonAuthoritive.data = [];

      var opHeading = OpForm.PronouncementType + " " + OpForm.Number + " Paragraph";
      this.columnDetails = [
        { columnDef: 'pronouncement', header: opHeading, sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
        { columnDef: 'chapter', header: "Chapter", sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
      ];
      this.glossaryColumnDetails = [
        { columnDef: 'pronouncement', header: opHeading, cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'glossaryTerm', header: "Section", cell: (element: any) => `${element.glossaryTerm}` },
        { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];
      this.data = true;
    }
    if ((!this.Op_form_enable) && (this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "COD";
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? data[0].currentRecordCount : 0;
          this.dataSource_standard_paragraph.data = data;
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })
      this.opColSpan = 2;
      this.codformValues = (CodificationForm.Section != null ? CodificationForm.Section : "") + (CodificationForm.CODType != null ? " " + CodificationForm.CODType : "") + (CodificationForm.TypeValue != null ? " " + CodificationForm.TypeValue : "");
      this.codformValues = this.codformValues.trim() == "" || this.codformValues == undefined ? "" : this.codformValues;

      this.columnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'section', sortHeader: 'yes', header: "Section " + this.codformValues, cell: (element: any) => `${element.section}` },
        { columnDef: 'chapter', sortHeader: 'yes', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];

      this.glossaryColumnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
        { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];
      this.data = true;
    }
    if ((!this.Op_form_enable) && (!this.Cod_form_enable) && (this.CIG_form_enable)) {
      this.SearchSection = "CIG";
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? data[0].currentRecordCount : 0;
          this.dataSource_standard_paragraph.data = data;
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })

      this.opColSpan = 2;
      this.cigformValues = "Chapter " + (CIGForm.Chapter != null ? CIGForm.Chapter : "") + (CIGForm.CIGType != null ? " " + CIGForm.CIGType : "") + (CIGForm.TypeValue != null ? " " + CIGForm.TypeValue : "");

      this.columnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement Type", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
        { columnDef: 'chapter', header: this.cigformValues, sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
      ];

      this.glossaryColumnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
        { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];

      this.data = true;
    }

  }
  CODReferenceTypeValueNgmodel;
  CODformTypeValueNgmodel;
  radioOP = true;
  radioCOD = false;
  radioCIG = false;
  totalResultCount: number = 0;
  resultCount: number = 0;
  completeData: any = [];
  GenerateReport(CodificationForm, OpForm, CIGForm) {
    this.buttonActive = false;
    this.generateReport = false;
    this.commonDataService.currentSortDirectionSTT.next('asc');
    this.data = false;
    this.columnDetails = [];
    this.dataSource_standard_paragraph.data = [];
    this.dataSource_standard_footnote.data = [];
    this.dataSource_standard_glossaryTerms.data = [];
    this.dataSource_standard_nonAuthoritive.data = [];
    this.dataSource_standard_questions.data = [];
    this.paragraphData = [];
    this.glossaryData = [];
    this.totalResultCount = 0;
    this.resultCount = 0;
    this.enableBackToTop = false;
    this.commonDataService.showLoader.next(true);

   
    /*localStorage.setItem("sourceTracingTool", JSON.stringify(sourceTracingTool))*/

    if (this.Op_form_enable && (!this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "OP";
      this.commonDataService.currentSortHeaderSTT.next(this.SearchSection);
      this.sourceTracingData = {
        Collection: "OP",
        SectionTitle: OpForm.PronouncementType == undefined ? "" : OpForm.PronouncementType,
        SectionNumber: OpForm.Number == undefined ? "" : OpForm.Number,
        ParaNumber: OpForm.TypeValue == undefined ? "" : OpForm.TypeValue,
        ParaType: OpForm.ParaType == undefined ? "" : OpForm.ParaType,
        AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
        pageNumber: 0
      }
      /*localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))*/
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.completeData = data.sort((a, b) => this.sortProcess(a, b, "asc", "pronouncement"));
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? 500 : 0;
          this.dataSource_standard_paragraph.data = data.slice(0, 500);
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })
      OpForm.PronouncementType = OpForm.PronouncementType == undefined ? "" : OpForm.PronouncementType;
      OpForm.Number = OpForm.Number == undefined ? "" : OpForm.Number;
      this.opColSpan = 1;
      this.standformValues = (OpForm.PronouncementType != null ? " " + OpForm.PronouncementType : "") + (OpForm.Number != null ? " " + OpForm.Number : "") + (OpForm.OPType != null ? " " + OpForm.OPType : "") + " " + (OpForm.TypeValue != null ? " " + OpForm.TypeValue : "");
      this.standformValues = this.standformValues.trim() == "" || this.standformValues == undefined ? "Pronouncement Type" : this.standformValues;
      var opHeading = OpForm.PronouncementType + " " + OpForm.Number + " Paragraph";
      if (this.hideCIGFromSTT) {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: opHeading, sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
        ];
      }
      else {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: opHeading, sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
          { columnDef: 'chapter', header: "Chapter", sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
        ];
      }
      this.data = true;
    }
    if ((!this.Op_form_enable) && (this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "COD";
      this.commonDataService.currentSortHeaderSTT.next(this.SearchSection);
      this.sourceTracingData = {
        Collection: "COD",
        SectionTitle: "",
        SectionNumber: CodificationForm.Section == undefined ? "" : CodificationForm.Section,
        ParaNumber: CodificationForm.TypeValue == undefined ? "" : CodificationForm.TypeValue,
        ParaType: CodificationForm.CODType == undefined ? "" : CodificationForm.CODType,
        AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
        pageNumber: 0
      }
      /*localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))*/
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.completeData = data.sort((a, b) => this.sortProcess(a, b, "asc", "section"));
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? 500 : 0;
          this.dataSource_standard_paragraph.data = data.slice(0, 500);
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })
      this.opColSpan = 2;
      this.codformValues = (CodificationForm.Section != null ? CodificationForm.Section : "") + (CodificationForm.CODType != null ? " " + CodificationForm.CODType : "") + (CodificationForm.TypeValue != null ? " " + CodificationForm.TypeValue : "");
      this.codformValues = this.codformValues.trim() == "" || this.codformValues == undefined ? "" : this.codformValues;
      if (this.hideCIGFromSTT) {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'section', sortHeader: 'yes', header: "Section " + this.codformValues, cell: (element: any) => `${element.section}` },
        ];

        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
        ];

      } else {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'section', sortHeader: 'yes', header: "Section " + this.codformValues, cell: (element: any) => `${element.section}` },
          { columnDef: 'chapter', sortHeader: 'yes', header: "Chapter", cell: (element: any) => `${element.chapter}` },
        ];

        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
          { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
        ];
      }


      this.data = true;
    }
    if ((!this.Op_form_enable) && (!this.Cod_form_enable) && (this.CIG_form_enable)) {
      this.SearchSection = "CIG";
      this.commonDataService.currentSortHeaderSTT.next(this.SearchSection);
      this.sourceTracingData = {
        Collection: "CIG",
        SectionTitle: "",
        SectionNumber: CIGForm.Chapter == undefined ? "" : CIGForm.Chapter,
        ParaNumber: CIGForm.TypeValue == undefined ? "" : CIGForm.TypeValue,
        ParaType: CIGForm.CIGType == undefined ? "" : CIGForm.CIGType,
        AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
        pageNumber: 0
      }
      /*localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))*/
      this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
        if (data) {
          this.completeData = data.sort((a, b) => this.sortProcess(a, b, "asc", "chapter"));
          this.totalResultCount = data.length > 0 ? data[0].totalValue : 0;
          this.resultCount = data.length > 0 ? 500 : 0;
          this.dataSource_standard_paragraph.data = data.slice(0, 500);
          this.generateReport = true;
          this.commonDataService.showLoader.next(false);
        }
      })

      this.opColSpan = 2;
      this.cigformValues = "Chapter " + (CIGForm.Chapter != null ? CIGForm.Chapter : "") + (CIGForm.CIGType != null ? " " + CIGForm.CIGType : "") + (CIGForm.TypeValue != null ? " " + CIGForm.TypeValue : "");

      this.columnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement Type", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
        { columnDef: 'chapter', header: this.cigformValues, sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
      ];

      this.glossaryColumnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
        { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];

      this.data = true;
    }
  }
  pageNumber: number = 1;
  loadNextPage(CodificationForm, OpForm, CIGForm) {
    this.commonDataService.showLoader.next(true);
    if (this.Op_form_enable && (!this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "OP";
      this.pageNumber++;
      //this.sourceTracingData = {
      //  Collection: "OP",
      //  SectionTitle: OpForm.PronouncementType == undefined ? "" : OpForm.PronouncementType,
      //  SectionNumber: OpForm.Number == undefined ? "" : OpForm.Number,
      //  ParaNumber: OpForm.TypeValue == undefined ? "" : OpForm.TypeValue,
      //  ParaType: OpForm.ParaType == undefined ? "" : OpForm.ParaType,
      //  AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
      //  pageNumber: this.sourceTracingData.pageNumber + 1
      //}
      //localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))
      this.getSourceTracingReport();
      OpForm.PronouncementType = OpForm.PronouncementType == undefined ? "" : OpForm.PronouncementType;
      OpForm.Number = OpForm.Number == undefined ? "" : OpForm.Number;
      this.opColSpan = 1;
      this.standformValues = (OpForm.PronouncementType != null ? " " + OpForm.PronouncementType : "") + (OpForm.Number != null ? " " + OpForm.Number : "") + (OpForm.OPType != null ? " " + OpForm.OPType : "") + " " + (OpForm.TypeValue != null ? " " + OpForm.TypeValue : "");
      this.standformValues = this.standformValues.trim() == "" || this.standformValues == undefined ? "Pronouncement Type" : this.standformValues;
      // this.dataSource_standard_glossaryTerms.data = [];
      this.dataSource_standard_nonAuthoritive.data = [];

      var opHeading = OpForm.PronouncementType + " " + OpForm.Number + " Paragraph";
      if (this.hideCIGFromSTT) {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: opHeading, sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` }
        ];
        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: opHeading, cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'glossaryTerm', header: "Section", cell: (element: any) => `${element.glossaryTerm}` }
        ];
      }
      else {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: opHeading, sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
          { columnDef: 'chapter', header: "Chapter", sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
        ];
        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: opHeading, cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'glossaryTerm', header: "Section", cell: (element: any) => `${element.glossaryTerm}` },
          { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
        ];
      }
      this.data = true;
    }
    if ((!this.Op_form_enable) && (this.Cod_form_enable) && (!this.CIG_form_enable)) {
      this.SearchSection = "COD";
      this.pageNumber++;
      //this.sourceTracingData = {
      //  Collection: "COD",
      //  SectionTitle: "",
      //  SectionNumber: CodificationForm.Section == undefined ? "" : CodificationForm.Section,
      //  ParaNumber: CodificationForm.TypeValue == undefined ? "" : CodificationForm.TypeValue,
      //  ParaType: CodificationForm.CODType == undefined ? "" : CodificationForm.CODType,
      //  AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
      //  pageNumber: this.sourceTracingData.pageNumber + 1
      //}
      /*localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))*/
      this.getSourceTracingReport();
      this.opColSpan = 2;
      this.codformValues = (CodificationForm.Section != null ? CodificationForm.Section : "") + (CodificationForm.CODType != null ? " " + CodificationForm.CODType : "") + (CodificationForm.TypeValue != null ? " " + CodificationForm.TypeValue : "");
      this.codformValues = this.codformValues.trim() == "" || this.codformValues == undefined ? "" : this.codformValues;
      if (this.hideCIGFromSTT) {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'section', sortHeader: 'yes', header: "Section " + this.codformValues, cell: (element: any) => `${element.section}` }
        ];

        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` }
        ];
      } else {
        this.columnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'section', sortHeader: 'yes', header: "Section " + this.codformValues, cell: (element: any) => `${element.section}` },
          { columnDef: 'chapter', sortHeader: 'yes', header: "Chapter", cell: (element: any) => `${element.chapter}` },
        ];

        this.glossaryColumnDetails = [
          { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
          { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
          { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
          { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
        ];
      }
      this.data = true;
    }
    if ((!this.Op_form_enable) && (!this.Cod_form_enable) && (this.CIG_form_enable)) {
      this.SearchSection = "CIG";
      this.pageNumber++;
      //this.sourceTracingData = {
      //  Collection: "CIG",
      //  SectionTitle: "",
      //  SectionNumber: CIGForm.Chapter == undefined ? "" : CIGForm.Chapter,
      //  ParaNumber: CIGForm.TypeValue == undefined ? "" : CIGForm.TypeValue,
      //  ParaType: CIGForm.CIGType == undefined ? "" : CIGForm.CIGType,
      //  AuthType: this.isPrimary == undefined ? "" : this.isPrimary,
      //  pageNumber: this.sourceTracingData.pageNumber + 1
      //}
      /*localStorage.setItem("sourceTracingToolData", JSON.stringify(this.sourceTracingData))*/
      this.getSourceTracingReport();
      this.opColSpan = 2;
      this.cigformValues = "Chapter " + (CIGForm.Chapter != null ? CIGForm.Chapter : "") + (CIGForm.CIGType != null ? " " + CIGForm.CIGType : "") + (CIGForm.TypeValue != null ? " " + CIGForm.TypeValue : "");

      this.columnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement Type", sortHeader: 'yes', cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", sortHeader: 'no', cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'section', header: "Section", sortHeader: 'yes', cell: (element: any) => `${element.section}` },
        { columnDef: 'chapter', header: this.cigformValues, sortHeader: 'yes', cell: (element: any) => `${element.chapter}` },
      ];

      this.glossaryColumnDetails = [
        { columnDef: 'pronouncement', header: "Pronouncement", cell: (element: any) => `${element.pronouncement}` },
        { columnDef: 'pronouncementPara', header: "Paragraph", cell: (element: any) => `${element.pronouncementPara}` },
        { columnDef: 'glossaryTerm', header: "Section " + this.codformValues, cell: (element: any) => `${element.glossaryTerm}` },
        { columnDef: 'chapter', header: "Chapter", cell: (element: any) => `${element.chapter}` },
      ];

      this.data = true;
    }
  }

  getSourceTracingReport() {
    /*this.generateReport = false;*/
    //this.graphQlService.getSourceTracingToolReport(this.sourceTracingData).subscribe(data => {
    //  if (data) {
    this.resultCount = this.pageNumber * 500;
    // this.paragraphData = this.paragraphData.concat(data.filter(x => !x.paraType.toLocaleLowerCase().includes("gloss")));
    // this.glossaryData = this.glossaryData.concat(data.filter(x => x.paraType.toLocaleLowerCase().includes("gloss")));
    this.dataSource_standard_paragraph.data = this.completeData.slice(0, this.completeData.length > ((this.pageNumber) * 500) ? ((this.pageNumber) * 500) : this.completeData.length);
    //this.dataSource_standard_paragraph.data=this.dataSource_standard_paragraph.data.sort((a,b)=>(a.sourceOpParaNumber_firstDigit - b.sourceOpParaNumber_firstDigit || a.sourceOpParaNumber_secondDigit - b.sourceOpParaNumber_secondDigit || a.sourceOpParaNumber_ThirdDigit - b.sourceOpParaNumber_ThirdDigit));
    //this.generateReport = true;
    this.commonDataService.showLoader.next(false);
    /*}*/
    /*})*/
  }

  setFocus() {
    document.getElementById("scrollList").scroll(0, 0);
  }
  openrightpanel(event) {
    let id = event.target.id
    if (id != null && id != undefined && id != "") {
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightOverlayOption.next(id);
      this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    }
  }
  enableBackToTop: boolean = false;

  EnableBackToTop() {

    var div = document.getElementById("scrollList");
    if (div != null) {
      var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

      if (hasVerticalScrollbar) {
        this.enableBackToTop = true;
      }
      else {
        this.enableBackToTop = false;
      }
    }
  }

  sortProcess(a: any, b: any, direction, sortingColumn) {
    let comparatorResult = 0;
    if (sortingColumn == "section") {
      comparatorResult = this.sttSort.SortSTTbySection(a, b);
      if (comparatorResult == 0) {
        comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
        if (comparatorResult == 0) {
          if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
            comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
            if (comparatorResult == 0) {
              comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
            }
          }
          else {
            comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
          }
        }
      }
    }
    else if (sortingColumn == "chapter") {
      comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
      if (comparatorResult == 0) {
        comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
        if (comparatorResult == 0) {
          if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
            comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
            
          }
          else {
            comparatorResult = this.sttSort.SortSTTbySection(a, b);
          }
        }
      }
    }
    else if (sortingColumn == "pronouncement") {
      comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
      if (comparatorResult == 0) {
        if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
          comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
          if (comparatorResult == 0) {
            comparatorResult = this.sttSort.SortSTTbySection(a, b);
            if (comparatorResult == 0) {
              comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
            }
          }
        }
        else {
          comparatorResult = this.sttSort.SortSTTbySection(a, b);
          if (comparatorResult == 0) {
            comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
          }
        }
      }
    }
    return comparatorResult * (direction == 'asc' ? 1 : -1);
  }
}
